export default __webpack_public_path__ + "static/media/monitoreo.b613eb0d.svg";